import React from 'react'
import { Box, Text, Center, Divider } from '@chakra-ui/react'

import { useTeamChatMessageProperties } from './properties-provider'
import { formatHumanReadableDate } from '~components/chats/chat/messages-list/message-content/message-helpers'

export default function TeamChatTimestamp() {
    const { message, isFirst, isPastLgThreshold, isPastSmThreshold } =
        useTeamChatMessageProperties()

    const formatted = formatHumanReadableDate(message.created_at)

    return (
        <>
            {isPastSmThreshold && <Box h={1} />}
            {(isPastLgThreshold || isFirst) && (
                <Center pt={4} pb={1} w="full" gridGap={2}>
                    <Divider flex={1} />
                    <Box>
                        <Text
                            fontSize="xs"
                            fontWeight="medium"
                            color="gray.500"
                        >
                            {formatted}
                        </Text>
                    </Box>
                    <Divider flex={1} />
                </Center>
            )}
        </>
    )
}
